import { DataActionType } from '@tencent/memoire-core';
var DataUpgradeTool = /** @class */ (function () {
    function DataUpgradeTool(collection) {
        this.collection = collection;
        this.versionActionsMap = new Map();
    }
    DataUpgradeTool.prototype.getVersionActionsMap = function () {
        return this.versionActionsMap;
    };
    DataUpgradeTool.prototype.version = function (version) {
        var _this = this;
        var upgrader = {
            update: function (updater) {
                _this.pushAction(version, {
                    type: DataActionType.ReplaceData,
                    replacer: updater,
                    collection: _this.collection,
                });
                return upgrader;
            },
            delete: function (filter) {
                _this.pushAction(version, {
                    filter: filter,
                    type: DataActionType.ClearData,
                    collection: _this.collection,
                });
                return upgrader;
            },
        };
        return upgrader;
    };
    DataUpgradeTool.prototype.pushAction = function (version, action) {
        var actions = this.versionActionsMap.get(version) || [];
        actions.push(action);
        this.versionActionsMap.set(version, actions);
    };
    return DataUpgradeTool;
}());
export default DataUpgradeTool;
//# sourceMappingURL=data-upgrade-tool.js.map